import { universal } from '../../components/loadable';

export const LoadableSkipLinks = universal(import('./SkipLinks'), {
  key: 'HotSkipLinks',
});
